module.exports = __webpack_public_path__ + "static/img/areaB_06.233c05c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_06.png
// module id = 1267
// module chunks = 1